<template>
  <div class="section-service" id="service">
    <div class="container">
      <ui-title class="section-service__title" text="Услуги" line/>
      <div class="section-service__content-wrap">    
        <div class="section-service__info">
          <ui-title class="section-service__info-title" text="Нагрузочное тестирование"/>
          <div class="section-service__desc">Проведение нагрузочного тестирования под ключ</div>
          <div class="section-service__desc">Построение процесса нагрузочного тестирования</div>
          <div class="section-service__desc">Автоматизация нагрузочного тестирования</div>
          <div class="section-service__desc">Оптимизация существующих процессов тестирования</div>
          <!--ui-title class="section-service__info-title" text="Школа обучения"/>
          <div class="section-service__desc">Обучение нагрузочному тестированию с нуля</div-->
          <!--<ui-title class="section-service__info-title" text="Используемые технологии"/>-->
          <div class="section-service__desc2">Используемые технологии:</div>
          <div class="section-service__desc">JMeter, HP LoadRunner, Gatling, Locust, k6.</div>
          <div class="section-service__desc"></div>
          <ui-button text="Заказать" @click="scrollToSlide('contact')"/>
          <div class="section-service__desc"></div>
        </div>
        <img class="section-service__image" src="@/assets/images/Service.png" />
      </div>
      <ui-title text="Процесс работы" line reverse/>
    </div>
  </div>
</template>

<script>
import UiTitle from '@/components/ui/UiTitle'
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    UiTitle,
    UiButton,
  },
  methods: {
    scrollToSlide(id) {
      this.$emit('scrollToSlide', id)
    },
  },
}
</script>

<style lang="scss">
@import "../../assets/scss/mixins.scss";

.section-service {
  display: flex;
  justify-content: center;
  padding: 40px 0;

  &__title {
    margin-bottom: 24px;
  }

  &__content-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    min-height: fit-content;
    gap: 11%;
    margin-bottom: 64px;

    @include breakpoint(desktop) {
      gap: 20px;
    }

    @include breakpoint(phablet) {
      flex-direction: column;
      align-items: center;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &-title {
      @include breakpoint(phablet) {
        width: 100%;
        text-align: center;
        justify-content: center;
      }
    }

    @include breakpoint(phablet) {
      align-items: center;
    }
  }
  
  &__desc {
    margin-bottom: 32px;

    @include breakpoint(phablet) {
      text-align: center;
    }
  }

  &__desc2 {
    font-weight: 500;
    font-size: 22px;
    line-height: 110%;
    letter-spacing: 0.1px;

    margin-bottom: 10px;
    @include breakpoint(phablet) {
      text-align: center;
    }
  }


  &__image {
    @include breakpoint(laptop) {
      width: 431px;
      height: 431px;
    }

    @include breakpoint(tablet) {
      width: 300px;
      height: 300px;
    }
  }
}
</style>
